import { ANALYTICS_BASE_URL } from './utils';

export async function fetchStatistics(data: Record<string, any>) {
  try {
    const {} = await fetch(`${ANALYTICS_BASE_URL}/log/record`, {
      method: 'POST',
      headers: {
        'x-api-key': ANALYTICS_KEY,
      },
      body: JSON.stringify({ ...data }),
    });
  } catch (e) {
    console.error('HIGHLIGHT SDK ERROR::' + JSON.stringify(e));
  }
}
